import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { useLogout } from '@/services/queries/authentication'
import { UserIcon } from '@heroicons/react/24/solid'

const LogoutButton = ({ loginUrl }: { loginUrl?: string }) => {
  const { isLogginOut, handleLogout } = useLogout({ loginUrl })

  return (
    <DropdownMenuItem
      onClick={() => {
        handleLogout()
      }}
      disabled={isLogginOut}
    >
      Log out
    </DropdownMenuItem>
  )
}

export const NavbarMenu = ({ loginUrl }: { loginUrl?: string }) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger>
        <Avatar className="bg-white text-black">
          <AvatarImage src="" />
          <AvatarFallback className="bg-white text-black">
            <UserIcon className="h-3.5 w-3.5" />
          </AvatarFallback>
        </Avatar>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <LogoutButton loginUrl={loginUrl} />
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
